import { Injectable } from '@angular/core';

import { SweetAlertParams } from './sweet-alert-params.model';

import * as _ from 'lodash';

import swal from 'sweetalert2';

@Injectable()
export class SweetAlertService {

  constructor() { }

  // Display a sweetAlert message of the type INFO.
  info(params: SweetAlertParams) {
    return this.alert(_.assign({ type: 'info' }, params));
  }

  // Display a sweetAlert message of the type WARNING.
  warning(params: SweetAlertParams) {
    return this.alert(_.assign({ type: 'warning' }, params));
  }

  // Display a sweetAlert message of the type QUESTION.
  question(params: SweetAlertParams) {
    return this.alert(_.assign({ type: 'question' }, params));
  }

  // Display a sweetAlert message of the type SUCCESS.
  success(params: SweetAlertParams) {
    return this.alert(_.assign({ type: 'success' }, params));
  }

  // Display a sweetAlert message of the type ERROR.
  error(params: SweetAlertParams) {
    return this.alert(_.assign({ type: 'error' }, params));
  }

  // Display a sweetAlert confirmation.
  confirmation(params: SweetAlertParams) {
    return swal({
      title: params.title || 'Atenção!',
      html: params.message,
      type: 'warning',
      allowOutsideClick: false,
      focusCancel: params.focusOk ? false : true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#1565c0',
      confirmButtonText: 'Ok',
      confirmButtonClass: 'ui large blue-bg bg-darken-3 white-text button waves-effect waves-light',
      cancelButtonColor: '#E0E1E2',
      cancelButtonClass: 'ui large grey-text text-darken-4 button waves-effect waves-light ml-3',
    });
  }

  // Private method that allows display alerts messages through info, warning, question, success and error public methods.
  private alert(params: SweetAlertParams) {
    return swal({
      title: params.title || (['success', 'info'].includes(params.type) ? '' : 'Atenção!'),
      html: params.message,
      type: (params.type as any) || 'info',
      allowOutsideClick: true,
      confirmButtonColor: '#1565c0',
      confirmButtonText: 'Ok',
      confirmButtonClass: 'ui large blue-bg bg-darken-3 white-text button waves-effect waves-light'
    }
    ).catch((dismiss) => {  });
  }
}
